export const ANIMATE_OUT_SPEED = 200;
export const THROTTLE_TIME_DEFAULT = 100;
export const THROTTLE_TIME_SCROLL = 2000;
